import { connect } from 'react-redux';
import { switchNetworkRequest } from '../../modules/wallet/actions';
import MetaTransactionError from './MetaTransactionError';
const mapState = (_state) => ({});
const mapDispatch = (dispatch) => ({
    onSwitchNetwork: chainId => dispatch(switchNetworkRequest(chainId))
});
export default connect(mapState, mapDispatch)(MetaTransactionError);
//# sourceMappingURL=MetaTransactionError.container.js.map